import { selectPlaceData } from 'containers/MapDetails/placeSlice'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ObjectMags from './ObjectMags'
import React from 'react'
import './style.scss'

interface MapDetailsProps {
  type?: 'map' | 'default'
}

const MapDetails: React.FC<MapDetailsProps> = ({ type = 'map' }) => {
  const place = useSelector(selectPlaceData)
  const { t } = useTranslation('mapDetails')
  const { goBack } = useHistory()

  switch (type) {
    case 'map': return (
      <div className='search__left'>
        <div className='search__left__title'>
          <div>
            <h2 className='--secFont'>{place.placeName}</h2>
            <p>{place.city}, {place.street} {place.estateNumber}{place.localNumber ? `/${place.localNumber}` : ''}</p>
          </div>
          <ArrowBtn text={t('back')} action={goBack} className='--reverse --black' />
        </div>
        <div className='search__left__content'>
          <ObjectMags />
        </div>
      </div>
    )

    default: return (
      <div className='objectMags__wrapper'>
        {place?.id && <div className='title'>
          <div>{place.city}, {place.street} {place.estateNumber}{place.localNumber ? `/${place.localNumber}` : ''}</div>
          <div>{t('selectSize')}</div>
        </div>}
        <ObjectMags />
      </div>
    )
  }
}

export default MapDetails
